// @flow
import React from 'react'

import { Flex, Label } from 'components/common'
import RadioButton from './radioButton'

import { useRadioButtonGroupStyles } from './styles'

type RadioButtonGroupProps<T = any> = {
  value: T,
  radioButtons: Array<{ label: string, value: T, isDisabled?: boolean }>,
  label?: string,
  isDisabled?: boolean,
  wrapperProps?: {
    [key: string]: any
  },
  onChange?: (value: T) => void
}

const RadioButtonGroup = ({
  isDisabled,
  value,
  label,
  radioButtons,
  onChange = () => {},
  wrapperProps = {}
}: RadioButtonGroupProps<any>) => {
  const classes = useRadioButtonGroupStyles()
  return (
    <Flex column>
      {label && <Label>{label}</Label>}
      <Flex className={classes.radioBtnGroup} {...wrapperProps}>
        {radioButtons.map(radioButton => (
          <RadioButton
            key={radioButton.value}
            checked={value === radioButton.value}
            disabled={isDisabled || radioButton.isDisabled}
            id={radioButton.value}
            label={radioButton.label}
            value={radioButton.value}
            onClick={onChange}
          />
        ))}
      </Flex>
    </Flex>
  )
}

export default RadioButtonGroup
